import { tsMenuItem } from '../../Typescript/UI_Interfaces'
import {
  Diversity1,
  Fastfood,
  FormatLineSpacing,
  HeartBroken,
  LocalShipping,
} from '@mui/icons-material'

const ReportMenu: tsMenuItem[] = [
  {
    path: '/stuart/report/cull',
    primaryText: 'Cull Report',
    leftIcon: <HeartBroken />,
  },
  {
    path: '/stuart/report/weaning',
    primaryText: 'Weaning Report',
    leftIcon: <Fastfood />,
  },
  {
    path: '/stuart/report/old-lines',
    primaryText: 'Lines not recently used',
    leftIcon: <FormatLineSpacing />,
  },
  {
    path: '/stuart/report/bp',
    primaryText: 'BP Litter >=',
    leftIcon: <Diversity1 />,
  },
  {
    path: '/stuart/report/shipping-manifest',
    primaryText: 'Shipping Manifest',
    leftIcon: <LocalShipping />,
  },
]

export default ReportMenu
